import React from 'react';
function UnorderedList({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 5h9" />
      <circle cx="6" cy="5" r="1.35" strokeLinecap="round" strokeLinejoin="round" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 12h9" />
      <circle cx="6" cy="12" r="1.35" strokeLinecap="round" strokeLinejoin="round" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 19h9" />
      <circle cx="6" cy="19" r="1.35" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default UnorderedList;
